import { render, staticRenderFns } from "./input.vue?vue&type=template&id=1370a63e&scoped=true"
import script from "./input.vue?vue&type=script&lang=tsx"
export * from "./input.vue?vue&type=script&lang=tsx"
import style0 from "./input.vue?vue&type=style&index=0&id=1370a63e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370a63e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1370a63e')) {
      api.createRecord('1370a63e', component.options)
    } else {
      api.reload('1370a63e', component.options)
    }
    module.hot.accept("./input.vue?vue&type=template&id=1370a63e&scoped=true", function () {
      api.rerender('1370a63e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/inbound/input.vue"
export default component.exports